import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

/**
 * Renders LocalBusiness JSON-LD with imported Google reviews so Google can show ⭐ rich snippets.
 * Mount once on the homepage.
 */
export default function ReviewsJsonLd() {
  const [reviews, setReviews] = useState<any[]>([]);

  useEffect(() => {
    supabase
      .from("seo_reviews_imported")
      .select("author_name, rating, review_text, published_at")
      .eq("is_visible", true)
      .order("published_at", { ascending: false })
      .limit(20)
      .then(({ data }) => setReviews(data ?? []));
  }, []);

  if (reviews.length === 0) return null;

  const avg = reviews.reduce((s, r) => s + Number(r.rating), 0) / reviews.length;

  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Altar Stone Countertops",
    url: "https://www.countertopsaltarstone.com",
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: avg.toFixed(1),
      reviewCount: reviews.length,
    },
    review: reviews.map((r) => ({
      "@type": "Review",
      author: { "@type": "Person", name: r.author_name },
      reviewRating: { "@type": "Rating", ratingValue: r.rating, bestRating: 5 },
      reviewBody: r.review_text,
      datePublished: r.published_at,
    })),
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />;
}
